import Animate from './Animate';
export default Animate;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-animate/src/index.js